import { StateType } from '../../../state/reducers';
import { CategoryEnum } from '../../search.types';

export function hasAggregation(
  aggregations: StateType['aggregations'],
  key: CategoryEnum,
): boolean {
  return aggregations[key] && aggregations[key].length > 0;
}

export function hasAggregationSelected(
  queryParams: StateType['queryParams'],
  name: CategoryEnum,
) {
  return queryParams.aggregationsPaths.some((item) => item.startsWith(name));
}
